module.exports = __webpack_public_path__ + "img/img_contact.ab4b1d64.png";